import React from "react";
import SubscriptionExpiredBanner from "organisms/banners/subscription-expired-banner";
import SubscriptionWarningBanner from "organisms/banners/subscription-warning-banner";
import { useGlobalState } from "utilities/contexts/use-global-state-context";
import RoleType from "utilities/enumerations/role-type";
import useSubscription from "utilities/hooks/domain/subscriptions/use-subscription";

const AccountSubscriptionInfoBanner = () => {
    const { globalState } = useGlobalState();
    const currentIdentity = globalState.currentIdentity;
    const currentUserRole = currentIdentity?.getCurrentUserRole();
    const currentRole = currentUserRole?.role;
    const isGroupAdmin = currentIdentity?.isGroupAdmin() ?? false;
    const { resultObject: subscription } = useSubscription(
        currentUserRole?.subscriptionId
    );

    const isExpired = currentUserRole?.isExpired() ?? false;
    const currentRoleIsTeam = currentRole?.is(RoleType.TEAM) ?? false;
    const userIsTeamMember = currentRoleIsTeam && !isGroupAdmin;
    const userIsEnterpriseAdmin =
        currentRole?.is(RoleType.ENTERPRISE) && isGroupAdmin;
    const isFreeTrialSubscription =
        currentRole?.is(RoleType.FREE_TRIAL) === true;
    const daysUntilExpiration =
        currentUserRole?.daysUntilSubscriptionExpiration();
    const subscriptionDaysWarning =
        globalState.systemSettings?.subscriptionExpirationWarningWindowInDays;

    const displaySubscriptionWarning =
        daysUntilExpiration! <= subscriptionDaysWarning! &&
        !isFreeTrialSubscription;

    // See FreeTrialBanner, which is placed higher up on the LiNK user dashboard
    if (isFreeTrialSubscription) {
        return;
    }

    return (
        <>
            {isExpired && !userIsTeamMember && (
                <SubscriptionExpiredBanner
                    userIsEnterpriseAdmin={userIsEnterpriseAdmin!}
                    subscriptionPin={subscription.sku}
                />
            )}
            {displaySubscriptionWarning && !isExpired && (
                <SubscriptionWarningBanner
                    daysUntilExpiration={daysUntilExpiration!}
                    userIsEnterpriseAdmin={userIsEnterpriseAdmin!}
                    displaySubscriptionWarning={displaySubscriptionWarning}
                    subscriptionPin={subscription.sku}
                />
            )}
        </>
    );
};

export default AccountSubscriptionInfoBanner;
